import { AddContactRequest, ContactsRequest, EditContactRequest, SingleContact } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useContacts() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [contact, setContact] = useState<SingleContact | null>(null);
  const [contacts, setContacts] = useState<SingleContact[]>([]);

  async function createContact(params: AddContactRequest) {
    try {
      setFetching(true);
      const res = await api.addContact(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return {
        contactID: res.ContactID,
      };
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  async function fetchContact(contactID: string) {
    try {
      setFetching(true);

      const res = await api.fetchContacts({
        ContactID: contactID,
      });

      if (!res.Success) throw new Error(res.ErrorMessage);

      const found = res.Contacts.find((a) => a.ContactID === contactID) || null;
      setContact(found);

      return found;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  async function fetchContacts(params: ContactsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchContacts(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setContacts(res.Contacts);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  async function editContact(params: EditContactRequest) {
    try {
      setFetching(true);
      const res = await api.editContact(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    createContact,
    contact,
    fetchContact,
    contacts,
    fetchContacts,
    editContact,
  };
}
